import React from "react";
import { Typography } from "antd";

import { W0, W1 } from "@components/Constants";

import CodeBlock from "./CodeBlock";

const DESCRIPTION = "Make a pair of keys on your machine. Keep the private key secret, because your client signs each ID token with it.";

const LABEL_STEP = "Step";

const LABEL_STEP_PRIVATE_KEY = "Make a private key of 2048 bits";
const LABEL_STEP_PUBLIC_KEY = "Make the public key that pairs with it";
const LABEL_STEP_SHOW = "Show the public key";
const LABEL_STEP_ADD = "Add the public key";
const DESCRIPTION_STEP_ADD = "Copy the output, and paste it into the Add Public Key form. Select the API of the key in the same form: one key serves one API.";

const COMMAND_PRIVATE_KEY = "openssl genrsa -out private.pem 2048";
const COMMAND_PUBLIC_KEY = "openssl rsa -in private.pem -pubout -out public.pem";
const COMMAND_SHOW = "cat public.pem";

const FIRST_STEP_NUMBER = 1;

type Step = {
  title: string;
  command?: string;
  description?: string;
};

const STEPS: Step[] = [
  {
    title: LABEL_STEP_PRIVATE_KEY,
    command: COMMAND_PRIVATE_KEY,
  },
  {
    title: LABEL_STEP_PUBLIC_KEY,
    command: COMMAND_PUBLIC_KEY,
  },
  {
    title: LABEL_STEP_SHOW,
    command: COMMAND_SHOW,
  },
  {
    title: LABEL_STEP_ADD,
    description: DESCRIPTION_STEP_ADD,
  },
];

const OrganizationPublicKeyGuide = (): JSX.Element => {
  const stepStyle = {
    marginBottom: W1,
  };

  const titleStyle = {
    marginBottom: W0 / 2,
  };

  const renderStep = ({ title, command, description }: Step, index: number) => {
    const stepNumber = index + FIRST_STEP_NUMBER;
    const stepTitle = `${LABEL_STEP} ${stepNumber}: ${title}`;
    const hasCommand = !!command;

    return (
      <div key={title} style={stepStyle}>
        <Typography.Paragraph style={titleStyle}>
          {stepTitle}
        </Typography.Paragraph>

        {hasCommand
          ? <CodeBlock isCopyable code={command} />
          : (
            <Typography.Text type="secondary">
              {description}
            </Typography.Text>
          )}
      </div>
    );
  };

  return (
    <>
      <Typography.Paragraph type="secondary">
        {DESCRIPTION}
      </Typography.Paragraph>

      {STEPS.map(renderStep)}
    </>
  );
};

export default OrganizationPublicKeyGuide;
